import { useAuthStore } from "..";
import { IAccountState } from "../components/account/Account";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const useAccountUpdate = (): (accountState: IAccountState) => Promise<void> => {
    const authStore = useAuthStore();

    return async (accountState: IAccountState): Promise<void> => {
        try {
            await authStore.updateUserProfileSettings({
                firstName: accountState.firstName!,
                lastName: accountState.lastName!,
                companyName: accountState.companyName!,
                title: authStore.userSettings!.profileSettings.title,
            });

            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useAccountUpdate;